// @ts-ignore
import {Action} from "@ngrx/store";
import {Recurrence} from '@app/shared/models/recurrence.model';
import { Activity } from "@app/shared/models/activity.model";
import { ActivityTask } from '@models/activity-task.model';
import { MaintenancePlan } from "@app/shared/models/maintenancePlan.model";
import { PagedResponse } from "@app/shared/models/response.model";

// Add Recurrence
export const ADD_RECURRENCE = '[Maintenance] Add Recurrence';
export const ADD_RECURRENCE_SUCCESS = '[Maintenance] Add Recurrence Success';
export const ADD_RECURRENCE_FAILED = '[Maintenance] Add Recurrence Failure';

export class AddRecurrenceAction implements Action {
    readonly type = ADD_RECURRENCE;

    constructor(public payload: Recurrence) {
    }
}

export class AddRecurrenceSuccessAction implements Action {
    readonly type = ADD_RECURRENCE_SUCCESS;

    constructor(public payload: Recurrence) {
    }
}

export class AddRecurrenceFailedAction implements Action {
    readonly type = ADD_RECURRENCE_FAILED;

    constructor(public payload: any) {
    }
}

// Load Recurrences
export const LOAD_RECURRENCES = '[Maintenance] Load Recurrences';
export const LOAD_RECURRENCES_SUCCESS = '[Maintenance] Load Recurrences Success';
export const LOAD_RECURRENCES_FAILED = '[Maintenance] Load Recurrences Failure';

export class LoadRecurrencesAction implements Action {
    readonly type = LOAD_RECURRENCES;

    constructor(public payload: string = null) {
    }
}

export class LoadRecurrencesSuccessAction implements Action {
    readonly type = LOAD_RECURRENCES_SUCCESS;

    constructor(public payload: Recurrence[]) {
    }
}

export class LoadRecurrencesFailedAction implements Action {
    readonly type = LOAD_RECURRENCES_FAILED;

    constructor(public payload: any) {
    }
}

// Update Recurrence
export const UPDATE_RECURRENCE = '[Maintenance] Update Recurrence ';
export const UPDATE_RECURRENCE_SUCCESS = '[Maintenance] Update Recurrence Success';
export const UPDATE_RECURRENCE_FAILED = '[Maintenance] Update Recurrence Failure';


export class UpdateRecurrenceAction implements Action {
    readonly type = UPDATE_RECURRENCE;

    constructor(public recurrence: Recurrence) {
    }
}

export class UpdateRecurrenceSuccessAction implements Action {
    readonly type = UPDATE_RECURRENCE_SUCCESS;

    constructor(public payload: Recurrence) {
    }
}

export class UpdateRecurrenceFailedAction implements Action {
    readonly type = UPDATE_RECURRENCE_FAILED;

    constructor(public payload: any) {
    }
}

// Delete Recurrence
export const DELETE_RECURRENCE = '[Maintenance] Delete Recurrence';
export const DELETE_RECURRENCE_SUCCESS = '[Maintenance] Delete Recurrence Success';
export const DELETE_RECURRENCE_FAILED = '[Maintenance] Delete Recurrence Failure';


export class DeleteRecurrenceAction implements Action {
    readonly type = DELETE_RECURRENCE;

    constructor(public recurrence: Recurrence) {
    }
}

export class DeleteRecurrenceSuccessAction implements Action {
    readonly type = DELETE_RECURRENCE_SUCCESS;

    constructor(public payload: Recurrence) {
    }
}

export class DeleteRecurrenceFailedAction implements Action {
    readonly type = DELETE_RECURRENCE_FAILED;

    constructor(public payload: any) {
    }
}

// Add Activity
export const ADD_ACTIVITY = '[Activity] Add Activity';
export const ADD_ACTIVITY_SUCCESS = '[Activity] Add Activity Success';
export const ADD_ACTIVITY_FAILED = '[Activity] Add Activity Failure';

export class AddActivityAction implements Action {
    readonly type = ADD_ACTIVITY;

    constructor(public payload: Activity) {
    }
}

export class AddActivitySuccessAction implements Action {
    readonly type = ADD_ACTIVITY_SUCCESS;

    constructor(public payload: Activity) {
    }
}

export class AddActivityFailedAction implements Action {
    readonly type = ADD_ACTIVITY_FAILED;

    constructor(public payload: any) {
    }
}

// Load Activities
export const LOAD_ACTIVITIES = '[Activity] Load Activities';
export const LOAD_ACTIVITIES_SUCCESS = '[Activity] Load Activities Success';
export const LOAD_ACTIVITIES_FAILED = '[Activity] Load Activities Failure';

export class LoadActivitiesAction implements Action {
    readonly type = LOAD_ACTIVITIES;

    constructor(public payload: string = null) {
    }
}

export class LoadActivitiesSuccessAction implements Action {
    readonly type = LOAD_ACTIVITIES_SUCCESS;

    constructor(public payload: Activity[]) {
    }
}

export class LoadActivitiesFailedAction implements Action {
    readonly type = LOAD_ACTIVITIES_FAILED;

    constructor(public payload: any) {
    }
}

// Update Activities
export const UPDATE_ACTIVITIES = '[Activity] Update Activities';
export const UPDATE_ACTIVITIES_SUCCESS = '[Activity] Update Activities Success';
export const UPDATE_ACTIVITIES_FAILED = '[Activity] Update Activities Failure';

export class UpdateActivitiesAction implements Action {
    readonly type = UPDATE_ACTIVITIES;

    constructor(public payload: any) {
    }
}

export class UpdateActivitiesSuccessAction implements Action {
    readonly type = UPDATE_ACTIVITIES_SUCCESS;

    constructor(public payload: Activity[]) {
    }
}

export class UpdateActivitiesFailedAction implements Action {
    readonly type = UPDATE_ACTIVITIES_FAILED;

    constructor(public payload: any) {
    }
}

// Load Activity
export const LOAD_ACTIVITY = '[Activity] Load Activity';
export const LOAD_ACTIVITY_SUCCESS = '[Activity] Load Activity Success';
export const LOAD_ACTIVITY_FAILED = '[Activity] Load Activity Failure';

export class LoadActivityAction implements Action {
    readonly type = LOAD_ACTIVITY;

    constructor(public payload: number) {
    }
}

export class LoadActivitySuccessAction implements Action {
    readonly type = LOAD_ACTIVITY_SUCCESS;

    constructor(public payload: Activity) {
    }
}

export class LoadActivityFailedAction implements Action {
    readonly type = LOAD_ACTIVITY_FAILED;

    constructor(public payload: any) {
    }
}

// Update Activity
export const UPDATE_ACTIVITY = '[Maintenance] Update Activity ';
export const UPDATE_ACTIVITY_SUCCESS = '[Maintenance] Update Activity Success';
export const UPDATE_ACTIVITY_FAILED = '[Maintenance] Update Activity Failure';


export class UpdateActivityAction implements Action {
    readonly type = UPDATE_ACTIVITY;

    constructor(public payload: Activity) {
    }
}

export class UpdateActivitySuccessAction implements Action {
    readonly type = UPDATE_ACTIVITY_SUCCESS;

    constructor(public payload: Activity) {
    }
}

export class UpdateActivityFailedAction implements Action {
    readonly type = UPDATE_ACTIVITY_FAILED;

    constructor(public payload: any) {
    }
}

// Delete Activity
export const DELETE_ACTIVITY = '[Maintenance] Delete Activity';
export const DELETE_ACTIVITY_SUCCESS = '[Maintenance] Delete Activity Success';
export const DELETE_ACTIVITY_FAILED = '[Maintenance] Delete Activity Failure';


export class DeleteActivityAction implements Action {
    readonly type = DELETE_ACTIVITY;

    constructor(public payload: Activity) {
    }
}

export class DeleteActivitySuccessAction implements Action {
    readonly type = DELETE_ACTIVITY_SUCCESS;

    constructor(public payload: number) {
    }
}

export class DeleteActivityFailedAction implements Action {
    readonly type = DELETE_ACTIVITY_FAILED;

    constructor(public payload: any) {
    }
}

// Add Task
export const ADD_TASK = '[Task] Add Task';
export const ADD_TASK_SUCCESS = '[Task] Add Task Success';
export const ADD_TASK_FAILED = '[Task] Add Task Failure';

export class AddTaskAction implements Action {
    readonly type = ADD_TASK;

    constructor(public payload: ActivityTask, public activity: Activity) {
    }
}

export class AddTaskSuccessAction implements Action {
    readonly type = ADD_TASK_SUCCESS;

    constructor(public payload: ActivityTask) {
    }
}

export class AddTaskFailedAction implements Action {
    readonly type = ADD_TASK_FAILED;

    constructor(public payload: any) {
    }
}

// Load Tasks
export const LOAD_TASK = '[Task] Load Task';
export const LOAD_TASK_SUCCESS = '[Task] Load Task Success';
export const LOAD_TASK_FAILED = '[Task] Load Task Failure';

export class LoadTaskAction implements Action {
    readonly type = LOAD_TASK;

    constructor(public payload: number) {
    }
}

export class LoadTaskSuccessAction implements Action {
    readonly type = LOAD_TASK_SUCCESS;

    constructor(public payload: ActivityTask) {
    }
}

export class LoadTaskFailedAction implements Action {
    readonly type = LOAD_TASK_FAILED;

    constructor(public payload: any) {
    }
}

// Load Tasks
export const LOAD_TASKS = '[Task] Load Tasks';
export const LOAD_TASKS_SUCCESS = '[Task] Load Tasks Success';
export const LOAD_TASKS_FAILED = '[Task] Load Tasks Failure';

export class LoadTasksAction implements Action {
    readonly type = LOAD_TASKS;

    constructor(public payload: any = {}) {
    }
}

export class LoadTasksSuccessAction implements Action {
    readonly type = LOAD_TASKS_SUCCESS;

    constructor(public payload: ActivityTask[]) {
    }
}

export class LoadTasksFailedAction implements Action {
    readonly type = LOAD_TASKS_FAILED;

    constructor(public payload: any) {
    }
}

// Update Task Photos
export const UPDATE_TASK_PHOTOS = '[Task] Update Task Photos'
export const UPDATE_TASK_PHOTOS_SUCCESS = '[Task] Update Task Photos Success'
export const UPDATE_TASK_PHOTOS_FAILED = '[Task] Update Task Photos Failure'

export class UpdateTaskPhotosAction implements Action {
    readonly type = UPDATE_TASK_PHOTOS;

    constructor(public taskId: number, public payload: ActivityTask) {
    }
}

export class UpdateTaskPhotosSuccessAction implements Action {
    readonly type = UPDATE_TASK_PHOTOS_SUCCESS;

    constructor(public payload: ActivityTask) {
    }
}

export class UpdateTaskPhotosFailedAction implements Action {
    readonly type = UPDATE_TASK_PHOTOS_FAILED;

    constructor(public payload: any) {
    }
}

// Update Task
export const UPDATE_TASK = '[Maintenance] Update Task ';
export const UPDATE_TASK_SUCCESS = '[Maintenance] Update Task Success';
export const UPDATE_TASK_FAILED = '[Maintenance] Update Task Failure';


export class UpdateTaskAction implements Action {
    readonly type = UPDATE_TASK;

    constructor(public payload: ActivityTask, public activity: Activity) {
    }
}

export class UpdateTaskSuccessAction implements Action {
    readonly type = UPDATE_TASK_SUCCESS;

    constructor(public payload: ActivityTask) {
    }
}

export class UpdateTaskFailedAction implements Action {
    readonly type = UPDATE_TASK_FAILED;

    constructor(public payload: any) {
    }
}

// Delete Task
export const DELETE_TASK = '[Maintenance] Delete Task';
export const DELETE_TASK_SUCCESS = '[Maintenance] Delete Task Success';
export const DELETE_TASK_FAILED = '[Maintenance] Delete Task Failure';


export class DeleteTaskAction implements Action {
    readonly type = DELETE_TASK;

    constructor(public payload: number) {
    }
}

export class DeleteTaskSuccessAction implements Action {
    readonly type = DELETE_TASK_SUCCESS;

    constructor(public payload: number) {
    }
}

export class DeleteTaskFailedAction implements Action {
    readonly type = DELETE_TASK_FAILED;

    constructor(public payload: any) {
    }
}

// Add Plan
export const ADD_PLAN = '[Maitenance] Add Plan';
export const ADD_PLAN_SUCCESS = '[Maitenance] Add Plan Success';
export const ADD_PLAN_FAILED = '[Maitenance] Add Plan Failure';

export class AddPlanAction implements Action {
    readonly type = ADD_PLAN;

    constructor(public payload: MaintenancePlan) {
    }
}

export class AddPlanSuccessAction implements Action {
    readonly type = ADD_PLAN_SUCCESS;

    constructor(public payload: MaintenancePlan) {
    }
}

export class AddPlanFailedAction implements Action {
    readonly type = ADD_PLAN_FAILED;

    constructor(public payload: any) {
    }
}

// Load Plan
export const LOAD_PLAN = '[Maintenance] Load Maintenance Plan';
export const LOAD_PLAN_SUCCESS = '[Maintenance] Load Maintenance Plan Success';
export const LOAD_PLAN_FAILED = '[Maintenance] Load Maintenance Plan Failure';

export class LoadPlanAction implements Action {
    readonly type = LOAD_PLAN;

    constructor(public payload: number) {
    }
}

export class LoadPlanSuccessAction implements Action {
    readonly type = LOAD_PLAN_SUCCESS;

    constructor(public payload: MaintenancePlan) {
    }
}

export class LoadPlanFailedAction implements Action {
    readonly type = LOAD_PLAN_FAILED;

    constructor(public payload: any) {
    }
}

// Load Plan Tools
export const LOAD_PLAN_TOOLS = '[Maintenance] Load Maintenance Plan Tools';
export const LOAD_PLAN_TOOLS_SUCCESS = '[Maintenance] Load Maintenance Plan Tools Success';
export const LOAD_PLAN_TOOLS_FAILED = '[Maintenance] Load Maintenance Plan Tools Failure';

export class LoadPlanToolsAction implements Action {
    readonly type = LOAD_PLAN_TOOLS;

    constructor(public payload: number) {
    }
}

export class LoadPlanToolsSuccessAction implements Action {
    readonly type = LOAD_PLAN_TOOLS_SUCCESS;

    constructor(public payload: any[]) {
    }
}

export class LoadPlanToolsFailedAction implements Action {
    readonly type = LOAD_PLAN_TOOLS_FAILED;

    constructor(public payload: any) {
    }
}

// Load Plans
export const LOAD_PLANS = '[Maintenance] Load Maintenance Plans';
export const LOAD_PLANS_SUCCESS = '[Maintenance] Load Maintenance Plans Success';
export const LOAD_PLANS_FAILED = '[Maintenance] Load Maintenance Plans Failure';

export class LoadPlansAction implements Action {
    readonly type = LOAD_PLANS;

    constructor(public config: any) {
    }
}

export class LoadPlansSuccessAction implements Action {
    readonly type = LOAD_PLANS_SUCCESS;

    constructor(public payload: PagedResponse<MaintenancePlan>, public firstPage: boolean) {
    }
}

export class LoadPlansFailedAction implements Action {
    readonly type = LOAD_PLANS_FAILED;

    constructor(public payload: any) {
    }
}

// Update Plan
export const UPDATE_PLAN = '[Maintenance] Update Plan ';
export const UPDATE_PLAN_SUCCESS = '[Maintenance] Update Plan Success';
export const UPDATE_PLAN_FAILED = '[Maintenance] Update Plan Failure';

export class UpdatePlanAction implements Action {
    readonly type = UPDATE_PLAN;

    constructor(public payload: MaintenancePlan, public incrementVersion: boolean) {
    }
}

export class UpdatePlanSuccessAction implements Action {
    readonly type = UPDATE_PLAN_SUCCESS;

    constructor(public payload: MaintenancePlan) {
    }
}

export class UpdatePlanFailedAction implements Action {
    readonly type = UPDATE_PLAN_FAILED;

    constructor(public payload: any) {
    }
}

// Delete Plan
export const DELETE_MAINTENANCE_PLAN = '[Maintenance] Delete Maintenance Plan';
export const DELETE_MAINTENANCE_PLAN_SUCCESS = '[Maintenance] Delete Maintenance Plan Success';
export const DELETE_MAINTENANCE_PLAN_FAILED = '[Maintenance] Delete Maintenance Plan Failure';


export class DeleteMaintenancePlanAction implements Action {
    readonly type = DELETE_MAINTENANCE_PLAN;

    constructor(public payload: MaintenancePlan) {
    }
}

export class DeleteMaintenancePlanSuccessAction implements Action {
    readonly type = DELETE_MAINTENANCE_PLAN_SUCCESS;

    constructor(public payload: number) {
    }
}

export class DeleteMaintenancePlanFailedAction implements Action {
    readonly type = DELETE_MAINTENANCE_PLAN_FAILED;

    constructor(public payload: any) {
    }
}

// Load Roles
export const LOAD_ROLES = '[Maintenance] Load Roles';
export const LOAD_ROLES_SUCCESS = '[Maintenance] Load Roles Success';
export const LOAD_ROLES_FAILED = '[Maintenance] Load Roles Failure';

export class LoadRolesAction implements Action {
    readonly type = LOAD_ROLES;

    constructor() {
    }
}

export class LoadRolesActionSuccessAction implements Action {
    readonly type = LOAD_ROLES_SUCCESS;

    constructor(public payload: number) {
    }
}

export class LoadRolesActionFailedAction implements Action {
    readonly type = LOAD_ROLES_FAILED;

    constructor(public payload: any) {
    }
}


// Load task work instruction files
export const LOAD_TASK_WORK_INSTRUCTION_FILES = '[Maintenance] Load task work instruction files';
export const LOAD_TASK_WORK_INSTRUCTION_FILES_SUCCESS = '[Maintenance] Load task work instruction files Success';
export const LOAD_TASK_WORK_INSTRUCTION_FILES_FAILED = '[Maintenance]Load task work instruction files Failure';

export class LoadTaskWorkInstructionFilesAction implements Action {
    readonly type = LOAD_TASK_WORK_INSTRUCTION_FILES;

    constructor(public operationId: number, public taskId: number) {
    }
}

export class LoadTaskWorkInstructionFilesSuccessAction implements Action {
    readonly type = LOAD_TASK_WORK_INSTRUCTION_FILES_SUCCESS;

    constructor(public payload: number) {
    }
}

export class LoadTaskWorkInstructionFilesFailedAction implements Action {
    readonly type = LOAD_TASK_WORK_INSTRUCTION_FILES_FAILED;

    constructor(public payload: any) {
    }
}

// Load task work instruction files
export const LOAD_TASK_SPARE_INSTRUCTION_FILES = '[Maintenance] Load task spare instruction files';
export const LOAD_TASK_SPARE_INSTRUCTION_FILES_SUCCESS = '[Maintenance] Load task spare instruction files Success';
export const LOAD_TASK_SPARE_INSTRUCTION_FILES_FAILED = '[Maintenance] Load task spare instruction files Failure';

export class LoadTaskSpareInstructionFilesAction implements Action {
    readonly type = LOAD_TASK_SPARE_INSTRUCTION_FILES;

    constructor(public operationId: number, public taskId: number) {
    }
}

export class LoadTaskSpareInstructionFilesSuccessAction implements Action {
    readonly type = LOAD_TASK_SPARE_INSTRUCTION_FILES_SUCCESS;

    constructor(public payload: number) {
    }
}

export class LoadTaskSpareInstructionFilesFailedAction implements Action {
    readonly type = LOAD_TASK_SPARE_INSTRUCTION_FILES_FAILED;

    constructor(public payload: any) {
    }
}

export type Action
    = AddRecurrenceAction
    | AddRecurrenceSuccessAction
    | AddRecurrenceFailedAction
    | LoadRecurrencesAction
    | LoadRecurrencesSuccessAction
    | LoadRecurrencesFailedAction
    | UpdateRecurrenceAction
    | UpdateRecurrenceSuccessAction
    | UpdateRecurrenceFailedAction
    | DeleteRecurrenceAction
    | DeleteRecurrenceSuccessAction
    | DeleteRecurrenceFailedAction
    | AddActivityAction
    | AddActivitySuccessAction
    | AddActivityFailedAction
    | LoadActivitiesAction
    | LoadActivitiesSuccessAction
    | LoadActivitiesFailedAction
    | UpdateActivitiesAction
    | UpdateActivitiesSuccessAction
    | UpdateActivitiesFailedAction
    | LoadActivityAction
    | LoadActivitySuccessAction
    | LoadActivityFailedAction
    | DeleteActivityAction
    | DeleteActivitySuccessAction
    | DeleteActivityFailedAction
    | UpdateActivityAction
    | UpdateActivitySuccessAction
    | UpdateActivityFailedAction
    | DeleteTaskAction
    | DeleteTaskSuccessAction
    | DeleteTaskFailedAction
    | UpdateTaskAction
    | UpdateTaskSuccessAction
    | UpdateTaskFailedAction
    | AddTaskAction
    | AddTaskSuccessAction
    | AddTaskFailedAction
    | UpdateTaskPhotosAction
    | UpdateTaskPhotosSuccessAction
    | UpdateTaskPhotosFailedAction
    | LoadTaskAction
    | LoadTaskSuccessAction
    | LoadTaskFailedAction
    | LoadTasksAction
    | LoadTasksSuccessAction
    | LoadTasksFailedAction
    | AddPlanAction
    | AddPlanSuccessAction
    | AddPlanFailedAction
    | LoadPlanAction
    | LoadPlanSuccessAction
    | LoadPlanFailedAction
    | LoadPlansAction
    | LoadPlansSuccessAction
    | LoadPlansFailedAction
    | DeleteMaintenancePlanAction
    | DeleteMaintenancePlanSuccessAction
    | DeleteMaintenancePlanFailedAction
    | LoadPlanToolsAction
    | LoadPlanToolsSuccessAction
    | LoadPlanToolsFailedAction
    | UpdatePlanAction
    | UpdatePlanSuccessAction
    | UpdatePlanFailedAction
    | LoadRolesAction
    | LoadRolesActionSuccessAction
    | LoadRolesActionFailedAction
    | LoadTaskWorkInstructionFilesAction
    | LoadTaskWorkInstructionFilesSuccessAction
    | LoadTaskWorkInstructionFilesFailedAction
    | LoadTaskSpareInstructionFilesAction
    | LoadTaskSpareInstructionFilesSuccessAction
    | LoadTaskSpareInstructionFilesFailedAction
